module.exports = __webpack_public_path__ + "static/media/14_PPE_Daniel Lo.5a195d83.jpeg";